import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { VexRoutes } from "src/@vex/interfaces/vex-route.interface";
import { CustomLayoutComponent } from "./custom-layout/custom-layout.component";
import { AuthGuard } from "./pages/auth/auth.guard";
import { DigitalServiceFormComponent } from "./pages/auth/digital-service-form/digital-service-form.component";
import { ThankyouComponent } from "./pages/auth/thankyou/thankyou.component";
import { DemoComponent } from "./demo/demo.component";
import { ThankComponent } from "./demo/thank/thank.component";
import { CheckEmail2Component } from "./pages/auth/check-email-2/check-email-2.component";
import { IncounterDetailsComponent } from "./pages/calendar/incounter-details/incounter-details.component";
import { ExitCodeFullscreenComponent } from "./pages/eval/evaluation/exit-code-fullscreen/exit-code-fullscreen.component";
import { UpdatePhoneComponent } from "./pages/auth/update-phone/update-phone.component";
import { UpdatePhoneThankYouComponent } from "./pages/auth/update-phone-thank-you/update-phone-thank-you.component";
import { LoginGuard } from "./pages/auth/login.gaurd";
import { LoginComponent } from "./pages/auth/login/login.component";
const childrenRoutes: VexRoutes = [
  {
    path: "dashboard",
    loadChildren: () =>
      import("./pages/dashboard/dashboard.module").then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: "admin",
    loadChildren: () =>
      import("./pages/auth/profile-tab/profile-tab.module").then(
        (m) => m.ProfileTabModule
      ),
  },
  {
    path: "encounter_details",
    component:IncounterDetailsComponent
  },
  
  {
    path: "calendar",
    loadChildren: () =>
      import("./pages/calendar/calendar-routing.module").then(
        (m) => m.CalendarRoutingModule
      ),
  },
  {
    path: "reporting",
    loadChildren: () =>
      import("./pages/reporting/reporting.module").then((m) => m.ReportingModule),
  },
//  { path:"applicant-form",component:ApplicantFormComponent},
  
  {
    path: "database",
    loadChildren: () =>
      import("./pages/user-management/user-management.module").then((m) => m.UserManagementModule),
  },
  { path: 'queue', loadChildren: () => import('./pages/queue/queue.module').then(m => m.QueueModule) },
  {
    path: "print-queue",
    loadChildren: () =>
      import("./pages/print-queue/print-queue.module").then(
        (m) => m.PrintQueueModule
      ),
  },
  {
    path: "reports",
    loadChildren: () =>
      import("./pages/reports/reports.module").then((m) => m.ReportsModule),
  },
  {
    path: "billing",
    loadChildren: () =>
      import("./pages/bill/bill.module").then((m) => m.BillModule),
  },
  {
    path: "pi",
    loadChildren: () =>
      import("./pages/pi/pi.module").then((m) => m.PiModule),
  },
];

const routes: Routes = [
  { path: 'exit-code', component: ExitCodeFullscreenComponent},
  {
    path: 'applicant/update-phone',
    component: UpdatePhoneComponent
  },
    {
    path: 'applicant/thank-you',
    component: UpdatePhoneThankYouComponent
  },
  {
    path: 'digitalService_acceptance_form',
    component: DigitalServiceFormComponent
  },
  {
    path: 'demographics_form',
    component: DemoComponent
  },
  {
    path: 'thankyou',
    component: ThankyouComponent
  },
  {
    path: 'check_email',
    component: CheckEmail2Component
  },
  {
    path: 'thank_you_for_request_form',
    component: ThankComponent
  },
  { path: "", redirectTo: "/login", pathMatch: "full" },
  { path: "login", component: LoginComponent, canActivate: [LoginGuard] },
  {
    path: "",
    component: CustomLayoutComponent,
    children: childrenRoutes,
    canActivate: [AuthGuard],
  },
  {
    path: "login",
    loadChildren: () =>
      import("./pages/auth/login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "forgot-password",
    loadChildren: () =>
      import("./pages/auth/check-email/check-email.module").then(
        (m) => m.CheckEmailModule
      ),
  },
  {
    path: "reset-password/:token",
    loadChildren: () =>
      import("./pages/auth/forgot-password/forgot-password.module").then(
        (m) => m.ForgotPasswordModule
      ),
  },
  {
    path: "error-500",
    loadChildren: () =>
      import("./pages/505/505.module").then((m) => m.Error505Module),
  },
  { path: 'reporting', loadChildren: () => import('./pages/reporting/reporting.module').then(m => m.ReportingModule) },
  


];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: "enabled",
      relativeLinkResolution: "corrected",
      anchorScrolling: "enabled",
      useHash: false,
      // enableTracing: true
      
    }),
  ],
  exports: [RouterModule],
  providers: [AuthGuard, LoginGuard],
})
export class AppRoutingModule {}
